import React, { useCallback, useEffect, useState } from "react";
import { SearchSelect, SearchSelectOptionProps } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

import { REGIONAL_TIMEZONES } from "../../constants";
import { getOffset, useTimezoneOperations } from "hooks/useTimezone";

const getLabelWithOffset = (zone: string) => `${zone} (${getOffset(zone)})`;

const getTimezonesListFormatted = () => {
	const newTimezonesConverted: SearchSelectOptionProps[] = [];
	for (const zone of REGIONAL_TIMEZONES) {
		newTimezonesConverted.push({
			value: zone,
			label: getLabelWithOffset(zone),
		} as SearchSelectOptionProps);
	}
	return newTimezonesConverted;
};

const useGetTimezonesListFormatted = () => {
	const [timezonesList, setTimezonesList] =
		useState<SearchSelectOptionProps[]>();

	useEffect(() => {
		setTimezonesList(getTimezonesListFormatted());
	}, []);

	return { timezonesList };
};

const useTimezoneSelect = () => {
	const { setTimezone, timezone } = useTimezoneOperations();
	const [selected, setSelected] = useState<SearchSelectOptionProps>({
		value: timezone,
		label: getLabelWithOffset(timezone),
	});

	const handleChangeTimezone = useCallback(
		(selected, action) => {
			setTimezone(selected.value);
			setSelected({
				value: selected.value,
				label: getLabelWithOffset(selected.value),
			});
		},
		[setTimezone]
	);

	return { selected, handleChangeTimezone };
};

const Timezone = () => {
	const { t } = useTranslation();
	const { timezonesList } = useGetTimezonesListFormatted();
	const { selected, handleChangeTimezone } = useTimezoneSelect();

	return (
		<SearchSelect
			label={t("main.profile.timezone")}
			value={selected}
			options={timezonesList}
			onChange={handleChangeTimezone}
		/>
	);
};

export default Timezone;
